import { createContext, useState } from 'react';
import { i18nTypes } from 'types';
import { i18n } from 'core';

export const i18nInstance = i18n();

export const AppIntlContext = createContext<Partial<i18nTypes.IntlShape>>({});

export function useIntl() {
  const [currentLocale, setCurrentLocale] = useState(i18nInstance.getCurrentLocale());

  function updateLocale(locale: i18nTypes.AcceptedLocale) {
    i18nInstance.setCurrentLocale(locale);
  }

  return {
    currentLocale,
    setCurrentLocale: (locale: i18nTypes.AcceptedLocale) => {
      updateLocale(locale);
      setCurrentLocale(locale);
    },
    t: i18nInstance.t,
    l: i18nInstance.l,
    acceptedLocales: i18nInstance.acceptedLocales,
  };
}
